const OPEN_NEW_CHAT_KEY = "ordinal:launch_pad_open_new_chat";

export function setLaunchPadOpenNewChat(kind: "research_assistant") {
  try {
    sessionStorage.setItem(OPEN_NEW_CHAT_KEY, kind);
  } catch {
    // ignore
  }
}

export function consumeLaunchPadOpenNewChat(): "research_assistant" | null {
  try {
    const value = sessionStorage.getItem(OPEN_NEW_CHAT_KEY);
    sessionStorage.removeItem(OPEN_NEW_CHAT_KEY);
    if (value === "research_assistant") {
      return value;
    }
    return null;
  } catch {
    return null;
  }
}
